import { Box } from '@mui/material'
import { omit } from 'ramda'
import MicroFrontendLoader from 'features/SystemLoaders/MicroFrontendLoader'
import { EpiEditorialBlock } from 'state/PublicWebApi/Settings'

export interface AvgangsersattningInfoBlockProps {
  content: {
    heading: string
    functionType: string
    urlKey: string
    blockKey: string
  }
}

const AvgangsersattningInfoBlock = (props: AvgangsersattningInfoBlockProps) => {
  const epiBlockContent: EpiEditorialBlock = omit(
    ['customDictionary', 'blockKey', 'customLinkDictionary'],
    props.content
  )
  epiBlockContent[props.content.blockKey] = props.content

  return (
    <Box>
      <MicroFrontendLoader
        currentKey={props.content.urlKey}
        functionType={props.content.functionType}
        editorBlockContent={epiBlockContent}
      />
    </Box>
  )
}

export default AvgangsersattningInfoBlock
